import React from 'react';
import {Link, StaticQuery, graphql} from 'gatsby';
import Img from 'gatsby-image';

import FormBasic from 'src/components/forms/FormBasic';
import styles from './Hero.module.scss';
import video from '../videos/video-hero.mp4';

const Hero = () => (
  <StaticQuery
    query={graphql`
      query {
        bg: file(relativePath: {eq: "bg-hero.jpg"}) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }

        logo: file(relativePath: {eq: "logo-hero.png"}) {
          childImageSharp {
            fluid(maxWidth: 262) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={(data) => (
      <section className={styles.container}>
        <Img
          critical={true}
          fluid={data.bg.childImageSharp.fluid}
          style={{position: false}}
        />

        <video
          autoPlay={true}
          className={styles.video}
          loop={true}
          muted={true}
          src={video}
        />

        <div className={styles.overlay}>
          <div className="wrap">
            <div className={styles.text}>
              <h1>
                <Link to="/">
                  <Img
                    alt="Sâmia Bomfim - deputada federal PSOL"
                    className={styles.logo}
                    critical={true}
                    fadeIn={false}
                    fluid={data.logo.childImageSharp.fluid}
                  />
                </Link>
              </h1>

              <FormBasic
                basic={{
                  channelId: '6034f027-8b54-4500-95cc-e5df458c303b',
                  title:
                    'Sâmia Bomfim é a deputada federal mais votada do PSOL-SP. Mantém uma postura aguerrida contra os retrocessos e está construindo um mandato coletivo, em prol dos Direitos Humanos, das mulheres e dos trabalhadores. Faça parte!',
                  initialValues: {subscribe: true},
                  showMateriais: true,
                  btnText: 'Participar',
                }}
                feedback="Muito obrigada pelo seu interesse e disposição de acompanhar de perto as iniciativas do nosso mandato! Enviamos um e-mail para confirmar seu cadastro."
              />
            </div>
          </div>
        </div>
      </section>
    )}
  />
);

export default Hero;
